export const inputs = [
    {
        columns: [
            {
                type: "checkbox",
                id: "showName",
                name: "showName",
                label: "Prikaži svoje ime i prezime (a ne samo korisničko ime)",
                required: false,
            },
            {
                type: "checkbox",
                id: "showOnline",
                name: "showOnline",
                label: "Prikaži svoj online status",
                required: false,
            },
        ],
    },
];
